function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_waybills_white");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon_waybills_white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-1",
  stroke: "#FFFFFF",
  points: "14.714672 2.1704102 18.87384 2.1704102 18.87384 27.2256472 0.5 27.2256472 0.5 2.1704102 4.609058 2.1704102"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-2",
  stroke: "#FFFFFF",
  points: "4.6757813 0.5 14.697876 0.5 14.697876 3.8406982 4.6757813 3.8406982"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-3",
  stroke: "#FFFFFF",
  points: "7.1565244 8.8349805 7.1565244 13.0108525 11.3323974 13.0108525"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-4",
  stroke: "#FFFFFF",
  points: "7.1565244 18.0219922 7.1565244 22.1978642 11.3323974 22.1978642"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-5",
  stroke: "#FFFFFF",
  points: "8.6174619 19.17474 9.7115399 20.402447 12.7181659 16.986582"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-6",
  stroke: "#FFFFFF",
  points: "8.6676943 9.9289588 9.7617763 11.1566658 12.7684023 7.7408009"
}));

var SvgIconWaybillsWhite = function SvgIconWaybillsWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "28px",
    viewBox: "0 0 20 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWaybillsWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_waybills_white.c761f720.svg";
export { ForwardRef as ReactComponent };